/* eslint-disable */
import React from 'react'
import Accordion from '../../components/accordion'
import Sidebar from './sidebar-help-center'
import { Col } from 'react-flexbox-grid'
import styled from 'styled-components'
import Helmet from 'react-helmet'

import { useTranslation } from 'react-i18next'

const HelpPageStyle = styled.div`
  @media screen and (min-width: 300px) and (max-width: 700px) {
    .sidebar-help-custom-navigation {
      width: 100% !important;
      margin-bottom: 20px;
    }

    .sidebar-help-custom-content {
      width: 100% !important;
      padding-left: 0 !important;
    }
  }
`

const HelpCenter = () => {
  const { t } = useTranslation()
  const data = [
    {
      title: t('pagePusatBantuan.part1'),
      number: 1,
      targetScroll: 'pusat-bantuan-1',
      child: {
        title: t('pagePusatBantuan.part2'),
        data: [
          {
            title: t('pagePusatBantuan.part3'),
            content: [
              {
                text: t('pagePusatBantuan.part4')
              },
              {
                text: t('pagePusatBantuan.part5')
              },
              {
                text: t('pagePusatBantuan.part6')
              },
              {
                text: t('pagePusatBantuan.part7')
              },
              {
                text: t('pagePusatBantuan.part8')
              },
              {
                text: t('pagePusatBantuan.part9')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part10'),
            content: [
              {
                text: t('pagePusatBantuan.part11')
              },
              {
                text: t('pagePusatBantuan.part12')
              },
              {
                text: t('pagePusatBantuan.part13')
              },
              {
                text: t('pagePusatBantuan.part14')
              },
              {
                text: t('pagePusatBantuan.part15')
              },
              {
                text: t('pagePusatBantuan.part16')
              },
              {
                text: t('pagePusatBantuan.part17')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePusatBantuan.part18'),
      number: 2,
      targetScroll: 'pusat-bantuan-2',
      child: {
        title: t('pagePusatBantuan.part19'),
        data: [
          {
            title: t('pagePusatBantuan.part20'),
            content: [
              {
                text: t('pagePusatBantuan.part21')
              },
              {
                text: t('pagePusatBantuan.part22')
              },
              {
                text: t('pagePusatBantuan.part23')
              },
              {
                text: t('pagePusatBantuan.part24')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part25'),
            content: [
              {
                text: t('pagePusatBantuan.part26')
              },
              {
                text: t('pagePusatBantuan.part27')
              },
              {
                text: t('pagePusatBantuan.part28')
              },
              {
                text: t('pagePusatBantuan.part29')
              },
              {
                text: t('pagePusatBantuan.part30')
              },
              {
                text: t('pagePusatBantuan.part31')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part32'),
            content: [
              {
                text: t('pagePusatBantuan.part33')
              },
              {
                text: t('pagePusatBantuan.part34')
              },
              {
                text: t('pagePusatBantuan.part35')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part36'),
            content: [
              {
                text: t('pagePusatBantuan.part37')
              },
              {
                text: t('pagePusatBantuan.part38')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePusatBantuan.part39'),
      number: 3,
      targetScroll: 'pusat-bantuan-3',
      child: {
        title: t('pagePusatBantuan.part40'),
        data: [
          {
            title: t('pagePusatBantuan.part41'),
            content: [
              {
                text: t('pagePusatBantuan.part42')
              },
              {
                text: t('pagePusatBantuan.part43')
              },
              {
                text: t('pagePusatBantuan.part44')
              },
              {
                text: t('pagePusatBantuan.part45')
              },
              {
                text: t('pagePusatBantuan.part46')
              },
              {
                text: t('pagePusatBantuan.part47')
              },
              {
                text: t('pagePusatBantuan.part48')
              },
              {
                text: t('pagePusatBantuan.part49')
              },
              {
                text: t('pagePusatBantuan.part50')
              },
              {
                text: t('pagePusatBantuan.part51')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part52'),
            content: [
              {
                text: t('pagePusatBantuan.part53')
              },
              {
                text: t('pagePusatBantuan.part54')
              },
              {
                text: t('pagePusatBantuan.part55')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePusatBantuan.part56'),
      number: 4,
      targetScroll: 'pusat-bantuan-4',
      child: {
        title: t('pagePusatBantuan.part57'),
        data: [
          {
            title: t('pagePusatBantuan.part58'),
            content: [
              {
                text: t('pagePusatBantuan.part59')
              },
              {
                text: t('pagePusatBantuan.part60')
              },
              {
                text: t('pagePusatBantuan.part61')
              },
              {
                text: t('pagePusatBantuan.part62')
              },
              {
                text: t('pagePusatBantuan.part63')
              },
              {
                text: t('pagePusatBantuan.part64')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part65'),
            content: [
              {
                text: t('pagePusatBantuan.part66')
              },
              {
                text: t('pagePusatBantuan.part67')
              },
              {
                text: t('pagePusatBantuan.part68')
              },
              {
                text: t('pagePusatBantuan.part69')
              },
              {
                text: t('pagePusatBantuan.part70')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part71'),
            content: [
              {
                text: t('pagePusatBantuan.part72')
              },
              {
                text: t('pagePusatBantuan.part73')
              },
              {
                text: t('pagePusatBantuan.part74')
              },
              {
                text: t('pagePusatBantuan.part75')
              },
              {
                text: t('pagePusatBantuan.part76')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part77'),
            content: [
              {
                text: t('pagePusatBantuan.part78')
              },
              {
                text: t('pagePusatBantuan.part79')
              },
              {
                text: t('pagePusatBantuan.part80')
              },
              {
                text: t('pagePusatBantuan.part81')
              },
              {
                text: t('pagePusatBantuan.part82')
              },
              {
                text: t('pagePusatBantuan.part83')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part84'),
            content: [
              {
                text: t('pagePusatBantuan.part85')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePusatBantuan.part86'),
      number: 5,
      targetScroll: 'pusat-bantuan-5',
      child: {
        title: t('pagePusatBantuan.part87'),
        data: [
          {
            title: t('pagePusatBantuan.part88'),
            content: [
              {
                text: t('pagePusatBantuan.part89')
              },
              {
                text: t('pagePusatBantuan.part90')
              },
              {
                text: t('pagePusatBantuan.part91')
              },
              {
                text: t('pagePusatBantuan.part92')
              },
              {
                text: t('pagePusatBantuan.part93')
              },
              {
                text: t('pagePusatBantuan.part94')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePusatBantuan.part95'),
      number: 6,
      targetScroll: 'pusat-bantuan-6',
      child: {
        title: t('pagePusatBantuan.part96'),
        data: [
          {
            title: t('pagePusatBantuan.part97'),
            content: [
              {
                text: t('pagePusatBantuan.part98')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part99'),
            content: [
              {
                text: t('pagePusatBantuan.part100')
              },
              {
                text: t('pagePusatBantuan.part101')
              },
              {
                text: t('pagePusatBantuan.part102')
              },
              {
                text: t('pagePusatBantuan.part103')
              },
              {
                text: t('pagePusatBantuan.part104')
              },
              {
                text: t('pagePusatBantuan.part105')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part106'),
            content: [
              {
                text: t('pagePusatBantuan.part107')
              },
              {
                text: t('pagePusatBantuan.part108')
              },
              {
                text: t('pagePusatBantuan.part109')
              },
              {
                text: t('pagePusatBantuan.part110')
              },
              {
                text: t('pagePusatBantuan.part111')
              },
              {
                text: t('pagePusatBantuan.part112')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePusatBantuan.part113'),
      number: 7,
      targetScroll: 'pusat-bantuan-7',
      child: {
        title: t('pagePusatBantuan.part114'),
        data: [
          {
            title: t('pagePusatBantuan.part115'),
            content: [
              {
                text: t('pagePusatBantuan.part116')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part117'),
            content: [
              {
                text: t('pagePusatBantuan.part118')
              },
              {
                text: t('pagePusatBantuan.part119')
              },
              {
                text: t('pagePusatBantuan.part120')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePusatBantuan.part121'),
      number: 8,
      targetScroll: 'pusat-bantuan-8',
      child: {
        title: t('pagePusatBantuan.part122'),
        data: [
          {
            title: t('pagePusatBantuan.part123'),
            content: [
              {
                text: t('pagePusatBantuan.part124')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part125'),
            content: [
              {
                text: t('pagePusatBantuan.part126')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePusatBantuan.part127'),
      number: 9,
      targetScroll: 'pusat-bantuan-9',
      child: {
        title: t('pagePusatBantuan.part128'),
        data: [
          {
            title: t('pagePusatBantuan.part129'),
            content: [
              {
                text: t('pagePusatBantuan.part130')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part131'),
            content: [
              {
                text: t('pagePusatBantuan.part132')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePusatBantuan.part133'),
      number: 10,
      targetScroll: 'pusat-bantuan-10',
      child: {
        title: t('pagePusatBantuan.part134'),
        data: [
          {
            title: t('pagePusatBantuan.part135'),
            content: [
              {
                text: t('pagePusatBantuan.part136')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part137'),
            content: [
              {
                text: t('pagePusatBantuan.part138')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part139'),
            content: [
              {
                text: t('pagePusatBantuan.part140')
              },
              {
                text: t('pagePusatBantuan.part141')
              },
              {
                text: t('pagePusatBantuan.part142')
              },
              {
                text: t('pagePusatBantuan.part143')
              },
              {
                text: t('pagePusatBantuan.part144')
              },
              {
                text: t('pagePusatBantuan.part145')
              },
              {
                text: t('pagePusatBantuan.part146')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pagePusatBantuan.part147'),
      number: 11,
      targetScroll: 'pusat-bantuan-11',
      child: {
        title: t('pagePusatBantuan.part148'),
        data: [
          {
            title: t('pagePusatBantuan.part149'),
            content: [
              {
                text: t('pagePusatBantuan.part150')
              },
              {
                text: t('pagePusatBantuan.part151')
              },
              {
                text: t('pagePusatBantuan.part152')
              },
              {
                text: t('pagePusatBantuan.part153')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part154'),
            content: [
              {
                text: t('pagePusatBantuan.part155')
              },
              {
                text: t('pagePusatBantuan.part156')
              },
              {
                text: t('pagePusatBantuan.part157')
              },
              {
                text: t('pagePusatBantuan.part158')
              },
              {
                text: t('pagePusatBantuan.part159')
              },
              {
                text: t('pagePusatBantuan.part160')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part161'),
            content: [
              {
                text: t('pagePusatBantuan.part162')
              },
              {
                text: t('pagePusatBantuan.part163')
              },
              {
                text: t('pagePusatBantuan.part164')
              },
              {
                text: t('pagePusatBantuan.part165')
              }
            ]
          },
          {
            title: t('pagePusatBantuan.part166'),
            content: [
              {
                text: t('pagePusatBantuan.part167')
              },
              {
                text: t('pagePusatBantuan.part168')
              },
              {
                text: t('pagePusatBantuan.part169')
              },
              {
                text: t('pagePusatBantuan.part170')
              },
              {
                text: t('pagePusatBantuan.part171')
              }
            ]
          }
        ]
      }
    }
  ]
  return (
    <div style={{ width: '100%' }}>
      <HelpPageStyle>
        <Helmet>
          <title>Pusat Bantuan | halojasa.com</title>
          <meta charSet="utf-8" />
          <meta
            name="description"
            content="Bingung tidak kunjung menemukan jawaban yang Anda cari ? Silahkan hubungi pusat bantuan kami segera"
          />
          <meta property="og:title" content="Pusat Bantuan | halojasa.com" />
          <meta property="og:site_name" content="Halo Jasa" />
          <meta
            property="og:description"
            content="Bingung tidak kunjung menemukan jawaban yang Anda cari ? Silahkan hubungi pusat bantuan kami segera"
          />
          <meta
            property="og:url"
            content="https://halojasa.com/bantuan/pusat-bantuan/"
          />
          <meta
            property="og:image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta
            property="og:image:secure_url"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta property="og:image:type" content="image/png" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta
            property="og:image"
            itemProp="image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-sq.png"
          />
          <meta
            property="og:image:secure_url"
            itemProp="image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-sq.png"
          />
          <meta property="og:image:type" content="image/png" />
          <meta property="og:image:width" content="300" />
          <meta property="og:image:height" content="300" />
          <meta property="og:type" content="website" />
          <meta property="fb:app_id" content="951866408583742" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@pthalojasa" />
          <meta
            name="twitter:title"
            content="Bingung tidak kunjung menemukan jawaban yang Anda cari ? Silahkan hubungi pusat bantuan kami segera"
          />
          <meta
            name="twitter:description"
            content="Bingung tidak kunjung menemukan jawaban yang Anda cari ? Silahkan hubungi pusat bantuan kami segera"
          />
          <meta
            name="twitter:image:src"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta
            name="p:domain_verify"
            content="4e6fcb4deba1a02d84225fad69babc0b"
          />
          <meta name="keyword" content="pusat bantuan" />
          <link
            rel="canonical"
            href="https://halojasa.com/bantuan/pusat-bantuan/"
          />
        </Helmet>
        <Col
          style={{
            width: '350px',
            display: 'inline-block',
            verticalAlign: 'top'
          }}
          className="sidebar-help-custom-navigation"
        >
          <Sidebar />
        </Col>

        <Col
          style={{
            width: 'calc(100% - 350px)',
            display: 'inline-block',
            verticalAlign: 'top',
            boxSizing: 'border-box',
            paddingLeft: '20px'
          }}
          className="sidebar-help-custom-content"
        >
          {data.map(item => {
            return (
              <Accordion key={item.number} {...item} withNumber></Accordion>
            )
          })}
        </Col>
      </HelpPageStyle>
    </div>
  )
}

export default HelpCenter
